import {
    SET_QUESTNO_IQ,
    SET_FROM_IQ_REDIRECT,
    SET_SERVICES,
    SET_TRANSACTION_ITEMS,
    SET_CHANGEITEMS_RESULT,
    RESET_CHANGEITEMS_RESULT,
    REMOVE_SERVICE,
    SET_APLCATL,
    SET_VALID_EMAIL_ARRAY,
} from './mutations';

export const actions = {
    // 從問卷平台回來帶的參數
    setQuestNoIQ({ commit }, payload) {
        commit(SET_QUESTNO_IQ, payload);
    },
    // 從問卷平台回來要去的頁面名稱
    setFromIQRedirect({ commit }, payload) {
        commit(SET_FROM_IQ_REDIRECT, payload);
    },
    // 本保單所有能做的變更項目服務
    setTransactionItems({ commit }, payload) {
        commit(SET_TRANSACTION_ITEMS, payload);
    },

    // 存入變更項目 當下tab
    setServices({ commit }, payload) {
        commit(SET_SERVICES, payload);
    },
    // 刪除指定(一項)變更
    removeService({ commit }, code) {
        commit(REMOVE_SERVICE, { code, commit });
    },

    // 清除流程
    resetService({ commit }) {
        commit(SET_SERVICES, []);
        commit(SET_TRANSACTION_ITEMS, []);
        commit(RESET_CHANGEITEMS_RESULT, {});
        commit(SET_APLCATL, '');
        commit(SET_VALID_EMAIL_ARRAY, []);
    },

    // 交易項目
    setChangeItemsResult({ commit }, payload) {
        commit(SET_CHANGEITEMS_RESULT, payload);
    },

    // 變更大類編號
    setAplCatl({ commit }, payload) {
        commit(SET_APLCATL, payload);
    },
    /** Email有效性驗證紀錄 */
    setValidEmailArray({ commit }, payload) {
        commit(SET_VALID_EMAIL_ARRAY, payload);
    },
};
